<div class="vdd-sensor-container flex flex-row gap-[48px]">
  <div
    (mouseenter)="showInfoHover = true"
    (mouseleave)="showInfoHover = false"
    class="flex flex-col"
  >
    <span class="vdd-sensor-value">{{ currentValue.value }} {{ currentValue.unit }}</span>
    <span class="vdd-sensor-status">{{ 'TI_' + statusValue.value | translate }}</span>
    <div *ngIf="showInfoHover" class="vdd-sensor-info-hover flex flex-col">
      <div>
        <span
          >{{ 'TI_Value' | translate }}:
          <span class="vdd-sensor-value"
            >{{ currentValue.value }} {{ currentValue.unit }}</span
          ></span
        >
      </div>
      <div class="divider"></div>
      <div class="flex flex-row gap-[12px] justify-between items-stretch">
        <span>{{ 'TI_Max' | translate }}:</span
        ><span class="vdd-sensor-value">{{ maxValue.value }} {{ maxValue.unit }}</span>
      </div>
      <div class="flex flex-row gap-[12px] justify-between items-stretch">
        <span>{{ 'TI_Average' | translate }}:</span
        ><span class="vdd-sensor-value">{{ avgValue.value }} {{ avgValue.unit }}</span>
      </div>
      <div class="flex flex-row gap-[12px] justify-between items-stretch">
        <span>{{ 'TI_Min' | translate }}:</span
        ><span class="vdd-sensor-value">{{ minValue.value }} {{ minValue.unit }}</span>
      </div>
    </div>
  </div>
  <div class="flex flex-col xs:flex-[100%] xs:max-w-[100%]">
    <mat-progress-bar
      [value]="getCurrentValueAsPercentOfRange()"
      mode="determinate"
    ></mat-progress-bar>
    <div class="flex flex-row justify-between items-center">
      <span
        >{{ 'TI_Min' | translate }}:
        <span class="vdd-sensor-hint">{{ minValue.value }} {{ minValue.unit }}</span></span
      >
      <span
        >{{ 'TI_Max' | translate }}:
        <span class="vdd-sensor-hint">{{ maxValue.value }} {{ maxValue.unit }}</span></span
      >
    </div>
  </div>
</div>
